import React from 'react'
import propTypes from 'prop-types'

import './Tag.scss'

const Tag = ({ label, className }) => {
  return (
    <div className={`tag ${className}`}>
      <span>{label}</span>
    </div>
  )
}

Tag.propTypes = {
  label: propTypes.string.isRequired,
  className: propTypes.string,
}

export default Tag
